import React from 'react';
export var InputGroupContext = /*#__PURE__*/React.createContext({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/reactstrap/esm/InputGroupContext.js
// module id = 226
// module chunks = 0